import { render, staticRenderFns } from "./RedeEmpresas.vue?vue&type=template&id=8773e16c&scoped=true&"
import script from "./RedeEmpresas.vue?vue&type=script&lang=js&"
export * from "./RedeEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./RedeEmpresas.vue?vue&type=style&index=0&id=8773e16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8773e16c",
  null
  
)

export default component.exports